import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import aiCreationImage from "@/assets/agent-user-detail/ai-creation@3x.webp";

export const AiCreationImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[aiCreationImage]}
      {...props}
    />
  );
};

AiCreationImage.displayName = 'AiCreationImage';
